import React, { useState } from "react";
import "./ProductDescription.scss";
import EnquirePopup from "../EnquirePopup";

const ProductDescription = () => {
   const [showPopup, setShowPopup] = useState(false);
  

  const OpneLinkHandle = () =>{
    window.open("https://app.businessbay.io/register", "_blank");
  }
  const handlePopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div>
      <div className="product_description_main_wrapper">
        <div className="product_description_upper_wrapper">
          <div className="product_description_heading_wrapper">Transform Your Culinary Passion</div>
          {/* <div className="product_description_title_wrapper">
            <span>Food Business?</span>
          </div> */}
        </div>
        <div className="product_description_para_wrapper">Partner with us to elevate your restaurant visibility. Leverage powerful marketing tools and analytics to understand your audience better and optimize your offerings.</div>
        <div className="product_description_button_wrapper">
          <button
          //  onClick={OpneLinkHandle}
          onClick={handlePopup}
           >Start Selling</button>
        </div>
      </div>
      {showPopup && (
               <EnquirePopup   open={showPopup} onClose={closePopup} setOpen={setShowPopup}/>
              )}
    </div>
  );
};

export default ProductDescription;
